import { render, staticRenderFns } from "./AnalyticsBarChartLabels.vue?vue&type=template&id=7825c860&"
import script from "./AnalyticsBarChartLabels.vue?vue&type=script&lang=js&"
export * from "./AnalyticsBarChartLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports